// extracted by css-extract-rspack-plugin
export default {"menu":"AvatarMenu_menu__NxqoZ","menuItem":"AvatarMenu_menuItem__or-wt","icon":"AvatarMenu_icon__Xze5k"};